import { z } from "zod";

export const usersMeSettingsSchema = z.object({
  global: z.object({
    is_post_prayer_streak_enabled: z.string().optional(),
  }),
  per_community: z.object({}),
  per_device: z.object({}),
  per_user: z.object({}),
});

export type UsersMeSettingsSchema = z.infer<typeof usersMeSettingsSchema>;
